import request from '@/config/axios'
export const getPointRulePage = (params: any) => request.get({ url: '/ai/point-rule/page', params })
export const savePointRule = (data: any) => request.put({ url: '/ai/point-rule/update', data })
export const deletePointRule = (id: number) => request.delete({ url: '/ai/point-rule/delete', params: { id } })
